<template>
	<section class="contentblocks">
		<div v-for="(item, index) in items" :key="index" class="contentblock row">
			<div v-if="item.content" class="columns column6 content">
				<h2>{{ item.header }}</h2>
				<div v-parse-links v-html="item.content" />
			</div>
			<image-slider :images="item.images" />
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	margin: 25px auto 0;
	padding: 0 75px;

	.row {
		margin-left: 620px;
	}
}

.row {
	width: auto;
	max-width: 1000px;
	margin: 60px auto 0;
	padding: 15px 0;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	align-items: stretch;

	&:nth-child(even) {
		flex-flow: row-reverse wrap;
	}

	.column12 {
		max-width: 900px;
	}

	.column6 {
		padding: 0;
	}

	.content {
		padding: 50px;
		border: 1px solid;
		display: flex;
		flex-flow: column wrap;
		justify-content: center;
		align-items: flex-start;

		:deep(p:last-child) {
			margin-bottom: 0;
		}
	}
}

@media (max-width: 1180px) {
	.contentblocks {
		.row {
			margin-left: 560px;
		}
	}
}

@media (max-width: 1080px) {
	.contentblocks {
		.row {
			margin-left: auto;
		}
	}
}

@media (max-width: 900px) {
	.row {
		flex-flow: column-reverse wrap;
		width: 100%;
		padding: 15px 30px;

		&:nth-child(even) {
			flex-flow: column-reverse wrap;
		}

		.content {
			padding: 40px;
		}
	}
}

@media (max-width: 750px) {
	.contentblocks {
		margin: 0 auto -110px;
		padding: 0;
	}
}
</style>
